import { useCallback, useEffect, useRef } from 'react';
// @ts-expect-error ts-migrate(7016)
import { setupCsat } from 'wootric-nps/csat/csat-setup';
import { WIDGET_MESSAGE_ACTIONS } from '../constants/widgetMessageActions';
import { useHelpMessageHandler } from './useHelpMessageHandler';
export const useHelpCsatSurvey = () => {
  const surveyTimerId = useRef(null);
  const surveyTimeoutTimestamp = useRef(null);
  const surveyTimeout = useRef(null);
  const resetTimeoutProperties = useCallback(() => {
    surveyTimerId.current = null;
    surveyTimeoutTimestamp.current = null;
    surveyTimeout.current = null;
  }, []);
  const handleCsatSurvey = useCallback(payload => {
    if (!payload || typeof payload.key !== 'string') {
      return;
    }

    // Set the timestamp for when the survey was triggered
    surveyTimeoutTimestamp.current = Date.now();

    // If a valid timeout is provided, trigger the survey after the timeout period
    if (typeof payload.timeout === 'number') {
      const timerId = setTimeout(() => {
        setupCsat(payload.key);
        resetTimeoutProperties();
      }, payload.timeout);

      // Store the timer ID and timeout period
      surveyTimerId.current = timerId;
      surveyTimeout.current = payload.timeout;
    }
  }, [resetTimeoutProperties]);
  const cancelCsatSurvey = useCallback(() => {
    if (surveyTimerId.current && surveyTimeoutTimestamp.current) {
      // Check if the timeout period has passed or not
      if (Date.now() - surveyTimeoutTimestamp.current < (surveyTimeout.current || 0)) {
        clearTimeout(surveyTimerId.current);
        resetTimeoutProperties();
      }
    }
  }, [resetTimeoutProperties]);
  const messageCallback = useCallback((action, payload) => {
    if (action === WIDGET_MESSAGE_ACTIONS.CSAT_SURVEY) {
      handleCsatSurvey(payload);
    }
  }, [handleCsatSurvey]);
  useHelpMessageHandler(messageCallback);
  useEffect(() => {
    return () => {
      if (surveyTimerId.current) {
        clearTimeout(surveyTimerId.current);
      }
    };
  }, []);
  return {
    cancelCsatSurvey
  };
};
export default useHelpCsatSurvey;